<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-form-label style="margin-top: 20px;margin-right: 10px" for="serial_number">
                {{ $t('pos.bind_serial_to_switch') }}
            </kt-form-label>
            <hr style="width:100%">
            <kt-panel-body>
                <form @submit.prevent="submit" id="bind_serial_to_switch">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="product_serial">
                                    {{ $t('pos.serial_number') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="product_serial"
                                        name="product_serial"
                                        v-model="product_serial"
                                        class="form-control"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-form-action class="mt-4">
                        <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                @click="sendSerialNmber"
                                v-bind:wide="true"
                                id="submit_btn"
                        >
                            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                        </kt-button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'


export default {
    components: {
        'main-content': mainContent,
    },
    computed: {},
    mounted() {

    },
    methods: {
        sendSerialNmber(e) {
            let form = $('#bind_serial_to_switch')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            let params = {
                terminal_id: this.terminal_id,
                product_serial: this.product_serial,
            }
            posService.bindSerial(params).then(response => {
                this.$router.push('/pos')
            })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        }
    },
    data() {
        return {
            product_serial: '',
            terminal_id: this.$route.params.terminal_id,
        }
    },
}
</script>

<style>

</style>